import axios from './axios-node-instance'

export default {
  getAllStudents (payload) {
    return axios.get('user/students/', { params: payload })
  }
}
